export default function _footerScripts() {
    const SCROLL_TO_TOP = document.querySelector(
        '[data-click="scroll-to-top"]'
    );

    class FooterMechanics {
        constructor({ scrollTop }) {
            this.scrollTop = scrollTop;
        }

        _scrollToTop() {
            document.body.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }

        init() {
            this.scrollTop.addEventListener(
                'click',
                this._scrollToTop.bind(this)
            );
        }
    }

    const footerMech = new FooterMechanics({
        scrollTop: SCROLL_TO_TOP,
    });

    footerMech.init();
}

document.addEventListener('DOMContentLoaded', function () {
    _footerScripts();
});
